module.exports = __webpack_public_path__ + "img/perfect-money.7e2fb60d.svg";